import React, { useState,useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { LoginContext } from '../contexts/logincontext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const {loggedInUser,changeLoggedInUser,getUser} = useContext(LoginContext);

  const token = localStorage.getItem("gymtoken");
  const type = localStorage.getItem("gymusertype");

  useEffect(() => {
    console.log(token,type)
    if (token) {
      if (type === 'client') {
        navigate('/customerdashboard');
      } else if (type === 'trainer') {
        navigate('/trainerdashboard');
      } else if (type === 'admin') {
        navigate('/admindashboard');
      }
    }
  }, []);


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post("https://klimkaara-backend-pgnq.onrender.com/user/login", {
        username: username,
        password: password,
      });
      if (response.status === 200) {
        // Navigate to dashboard based on user type
        changeLoggedInUser(response.data.user);
        localStorage.setItem('gymtoken', response.data.token);
        localStorage.setItem('gymusertype', response.data.type);
        const { type } = response.data;
        if (type === 'client') {
          navigate('/customerdashboard');
        } else if (type === 'trainer') {
          navigate('/trainerdashboard');
        } else if (type === 'admin') {
          navigate('/admindashboard');
        }
      }
    } catch (error) {
      setError(error.response.data.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-yellow-400 mb-6">Login</h2>
        
        <form onSubmit={handleLogin}>
          {/* Username Input */}
          <div className="mb-4">
            <label htmlFor="username" className="block text-gray-300 mb-2">Username</label>
            <input
              type="text"
              id="username"
              className="w-full px-4 py-2 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          {/* Password Input */}
          <div className="mb-4">
            <label htmlFor="password" className="block text-gray-300 mb-2">Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              className="w-full px-4 py-2 bg-gray-700 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* Show Password Checkbox */}
          <div className="mb-6 flex items-center">
            <input
              type="checkbox"
              id="show-password"
              className="mr-2"
              checked={showPassword}
              onChange={(e) => setShowPassword(e.target.checked)}
            />
            <label htmlFor="show-password" className="text-gray-300">Show Password</label>
          </div>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          {/* Login Button */}
          <button
            type="submit"
            className="w-full bg-yellow-400 text-gray-900 py-2 rounded-md font-semibold hover:bg-yellow-500 transition duration-300 text-center"
            disabled={loading}
          >
            <div className="flex items-center justify-center">
              {loading && (
                <svg
                  className="animate-spin h-5 w-5 text-white mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              )}
              <span>{loading ? 'Loading...' : 'Login'}</span>
            </div>
          </button>
        </form>

        {/* Forgot Password and Sign Up Links */}
        {/* <div className="text-center mt-6">
          <a href="#forgot-password" className="text-gray-400 hover:text-yellow-400">Forgot your password?</a>
        </div> */}
      </div>
    </div>
  );
};

export default Login;


